import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { TrendMetric } from '../services/metric.service';

@Pipe({
  name: 'filterTrendMetric',
  standalone: true
})
@Injectable()
export class FilterTrendMetricPipe implements PipeTransform {

  public transform(value: TrendMetric[], searchValue: string): TrendMetric[] {
    if (!searchValue || searchValue.length < 3) {
      return value;
    }
    const pattern = new RegExp('\\b' + searchValue.toLocaleLowerCase());
    return value.filter((metric: TrendMetric) => pattern.test(metric.metricTitle.toLocaleLowerCase() + ' ' + metric.metricInformation?.toLocaleLowerCase()));
  }
}
